import IdentifyFormContainer from 'components/Forms/TranslatorIdentify/IdentifyFormContainer'
import React from 'react'

const Identify = () => {
  return <IdentifyFormContainer />
}

export default Identify
